module.exports = __webpack_public_path__ + "static/media/uz.4b325d4e.svg";